module.exports = __webpack_public_path__ + "img/3.5657aadd.jpg";